export const USER_GROUP_PERMISSIONS_LOAD_STARTED =
  'USER_GROUP_PERMISSIONS_LOAD_STARTED';
export const USER_GROUP_PERMISSIONS_LOAD_FAILED =
  'USER_GROUP_PERMISSIONS_LOAD_FAILED';
export const USER_GROUP_PERMISSIONS_LOAD_SUCCESS =
  'USER_GROUP_PERMISSIONS_LOAD_SUCCESS';
